import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { Title } from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { useEmbeddedMode } from "@src/appV2/EmbeddedMode/EmbeddedModeContext";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";
import { useHasSignedContractorAgreement } from "@src/appV2/redesign/Accounts/hooks/useHasSignedContractorAgreement";
import { useHasSignedJobSearchAgreement } from "@src/appV2/redesign/Accounts/JobSearchAgreement/hooks/useHasSignedJobSearchAgreement";
import {
  DELETE_ACCOUNT_FULL_PATH,
  JOB_SEARCH_AGREEMENT_FULL_PATH,
} from "@src/appV2/redesign/Accounts/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { PRIVACY_POLICY_URL } from "../../constants/urls";
import { AccountListItem } from "../components/AccountListItem";

export function AccountsPageLegalSection() {
  const history = useHistory();
  const worker = useDefinedWorker();
  const { isEmbedded } = useEmbeddedMode();
  const { hasSigned: hasSignedContractorAgreement } = useHasSignedContractorAgreement();
  const { hasSigned: hasSignedJobSearchAgreement } = useHasSignedJobSearchAgreement();
  const workerHasRequestedDeletion = worker.stage === WorkerStage.DELETION_REQUESTED;

  return (
    <>
      <Title semibold component="h4" sx={(theme) => ({ paddingTop: theme.spacing(6) })}>
        Legal
      </Title>{" "}
      {!isEmbedded && hasSignedContractorAgreement && (
        <AccountListItem
          primaryText="Contractor Agreement"
          iconType="document"
          onClick={() => {
            history.push(DeprecatedGlobalAppV1Paths.PROFILE_CONTRACT);
          }}
        />
      )}
      {hasSignedJobSearchAgreement && (
        <AccountListItem
          primaryText="Job Search Agreement"
          iconType="document"
          onClick={() => {
            history.push(JOB_SEARCH_AGREEMENT_FULL_PATH);
          }}
        />
      )}
      <AccountListItem
        primaryText="Privacy Policy"
        iconType="privacy"
        onClick={async () => {
          await openInBrowser({ url: PRIVACY_POLICY_URL });
        }}
      />
      <AccountListItem
        fullWidthDivider
        primaryText={
          workerHasRequestedDeletion ? "Account Deletion Request Pending" : "Delete Account"
        }
        iconType="remove"
        onClick={() => {
          history.push(DELETE_ACCOUNT_FULL_PATH);
        }}
      />
    </>
  );
}
